import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustIndicators = () => {
  const securityFeatures = [
    {
      icon: "Shield",
      title: "SSL Encrypted",
      description: "Your data is protected with 256-bit SSL encryption"
    },
    {
      icon: "Lock",
      title: "Secure Login",
      description: "Multi-factor authentication available"
    },
    {
      icon: "Eye",
      title: "Privacy First",
      description: "We never share your personal information"
    }
  ];

  return (
    <div className="mt-8 pt-6 border-t border-border">
      <div className="text-center mb-4">
        <h3 className="font-heading font-heading-semibold text-sm text-foreground mb-2">
          Your Security Matters
        </h3>
        <p className="text-xs text-muted-foreground">
          We use industry-standard security measures to protect your account
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {securityFeatures?.map((feature, index) => (
          <div key={index} className="text-center">
            <div className="flex justify-center mb-2">
              <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center">
                <Icon name={feature?.icon} size={16} className="text-primary" />
              </div>
            </div>
            <h4 className="font-body font-body-medium text-xs text-foreground mb-1">
              {feature?.title}
            </h4>
            <p className="text-xs text-muted-foreground leading-relaxed">
              {feature?.description}
            </p>
          </div>
        ))}
      </div>
      <div className="flex items-center justify-center mt-6 space-x-4">
        <div className="flex items-center space-x-1">
          <Icon name="Shield" size={14} className="text-success" />
          <span className="text-xs text-muted-foreground">SSL Secured</span>
        </div>
        <div className="flex items-center space-x-1">
          <Icon name="Users" size={14} className="text-success" />
          <span className="text-xs text-muted-foreground">10,000+ Users</span>
        </div>
        <div className="flex items-center space-x-1">
          <Icon name="Star" size={14} className="text-success" />
          <span className="text-xs text-muted-foreground">4.8 Rating</span>
        </div>
      </div>
    </div>
  );
};

export default TrustIndicators;